<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col cols="12" lg="3">
        <div class="form-group">
          <label
            for="excmcar_name"
            class="form-control-label">{{$t('views.excmcar.form.name')}}:</label>
          <input
            id="excmcar_name"
            v-model="item.name"
            :class="['form-control', isInvalid('name') ? 'is-invalid' : '']"
            type="text"
            placeholder=""
            @input="handleUpdateField('name', $event.target.value)">
          <div
            v-if="isInvalid('name')"
            class="invalid-feedback">{{ violations.name }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="3">
        <div class="form-group">
          <label
            for="excmcar_model"
            class="form-control-label">{{$t('views.excmcar.form.model')}}:</label>
          <input
            id="excmcar_model"
            v-model="item.model"
            :class="['form-control', isInvalid('model') ? 'is-invalid' : '']"
            type="text"
            placeholder=""
            @input="handleUpdateField('model', $event.target.value)">
          <div
            v-if="isInvalid('model')"
            class="invalid-feedback">{{ violations.model }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="3">
        <div class="form-group">
          <label
            for="excmcar_registrationNumber"
            class="form-control-label">{{$t('views.excmcar.form.registrationNumber')}}:</label>
          <input
            id="excmcar_registrationNumber"
            v-model="item.registrationNumber"
            :class="['form-control', isInvalid('registrationNumber') ? 'is-invalid' : '']"
            type="text"
            placeholder=""
            @input="handleUpdateField('registrationNumber', $event.target.value)">
          <div
            v-if="isInvalid('registrationNumber')"
            class="invalid-feedback">{{ violations.registrationNumber }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="3">
        <div class="form-group">
          <label
            for="excmcar_type"
            class="form-control-label">{{$t('views.excmcar.form.type')}}:</label>
          <input
            id="excmcar_type"
            v-model="item.type"
            :class="['form-control', isInvalid('type') ? 'is-invalid' : '']"
            type="number"
            placeholder=""
            @input="handleUpdateField('type', $event.target.value)">
          <div
            v-if="isInvalid('type')"
            class="invalid-feedback">{{ violations.type }}</div>
        </div>
      </b-col>
    </b-row>

    <button
      type="submit"
      class="btn btn-success">{{ $t('buttons.submit') }}</button>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
